export default "__VITE_ASSET__292eac91__"